import { useMutation } from "react-query";
import { loginSellMode } from "../../../services/auth";
import { updateUserAccessCode } from "../../../services/business";

export const useLoginSellModeMutation = () => {
  return useMutation((data) => loginSellMode(data));
};

export const useCashierRestPinModeMutation = () => {
  return useMutation((data) => updateUserAccessCode(data));
};
